module.exports = __webpack_public_path__ + "img/slogan.cc166344.png";